'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseProps = exports.propTypes = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var propTypes = exports.propTypes = {
  width: _propTypes2.default.string,
  height: _propTypes2.default.string,
  minWidth: _propTypes2.default.string,
  minHeight: _propTypes2.default.string,
  maxWidth: _propTypes2.default.string,
  maxHeight: _propTypes2.default.string
};

var parseProps = exports.parseProps = function parseProps(_ref) {
  var width = _ref.width,
      height = _ref.height,
      minWidth = _ref.minWidth,
      minHeight = _ref.minHeight,
      maxWidth = _ref.maxWidth,
      maxHeight = _ref.maxHeight,
      style = _ref.style,
      props = _objectWithoutProperties(_ref, ['width', 'height', 'minWidth', 'minHeight', 'maxWidth', 'maxHeight', 'style']);

  var styles = {};

  if (width) {
    styles.width = width;
  }

  if (height) styles.height = height;

  if (minWidth) styles.minWidth = minWidth;
  if (minHeight) styles.minHeight = minHeight;
  if (maxWidth) styles.maxWidth = maxWidth;
  if (maxHeight) styles.maxHeight = maxHeight;

  return _extends({ style: _extends({}, styles, style) }, props);
};
//# sourceMappingURL=data:application/json;base64,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


//////////////////
// WEBPACK FOOTER
// ../~/@segment/react-ui-library/lib/enhancers/dimensions.js
// module id = 1144
// module chunks = 0